export default {
  nav: {
    home: '首页',
    orders: '交易',
    accounts: '账户',
    send: '转账',
    news: '新闻',
    assets: '资产',
    tokens: '代币',
    fees: '费用',
    files: '文件',
    logs: '日志',
    groups: '用户组',
    settings: '设置'
  },
  authentication: {
    login_title: "账号登录",
    login_button: "登录",
    login_button_progress: "登录中...",
    register_prompt: '还没有账号？点此注册',
    register_prompt_start: '还没有账号？',
    register_prompt_end: '点此注册',
    login_prompt: '已有账号？点此登录',
    register_title: "帐号注册",
    reset_password_title: '重置密码',
    register_next: '下一步',
    register_button: "注册",
    register_complete_button: '注册',
    register_button_progress: "注册中...",
    forgot_password_prompt: "忘记密码？",
    verification_incorrect: '验证码不正确',
    verification_title: '登录验证',
    login: "登录",
    register: "注册",
    welcome_help: "帮助中心",
    reset_button: "重置密码",
    reset_button_progress: "密码重置中...",
    verification_message: "验证码已发送至您注册的电子邮件，请输入验证码以重置您的密码。",
    verification_sms_title: '验证手机号码',
    verification_sms_message: '6位数的短信验证码已发送到您注册的手机号。',
    verification_sms_tips: '请输入您的验证码',
    verification_sms_progress: '登录中...',
    verification_pin_title: '验证识别码',
    verification_pin_message: '验证识别码',
    verification_pin_tips: '请输入您的识别码',
    verification_pin_progress: '登录中...',
    verification_password_title: '验证密码',
    verification_password_message: '验证密码',
    verification_password_tips: '请输入您的密码',
    verification_password_progress: '登录中...',
    verification_retry_after: '{{seconds}} 秒后重试',
    register_create_account: '创建一个新账号',
    account_recovery: '账号恢复',
    register_agree_terms: '通过点击上面的按钮，我同意',
    reset_with_security_questions: '通过安全问题重置密码',
    security_events_title: '登录日志',
    security_events_text: '您最近的登录日志',
    logout_session_button: '注销其他会话',
    logout_session_button_inprogress: '刷新中...',
    verification_email_message: '6位数的验证码已发送到您的邮箱中。',
    verification_totp_message: '请查看设备上的一次性密码。',
    login_with_phone: '使用电话号码登录',
    verification_new_email_sent_message: '已发送验证邮件您的新邮箱，请验证新邮箱。',
    home_login_prompt_start: '还没有账号?',
    home_login_prompt_end: '现在加入，成为变革的一部分。'
  },
  account: {
    accounts_title: '账户列表',
    summary_title: "余额",
    dashboard_title: "信息中心",
    dashboard_saving_usd: "USD 账户",
    dashboard_coin_xif: 'XIF 钱包',
    dashboard_coin_eth: 'ETH 钱包',
    dashboard_coin_btc: 'BTC 钱包',
    dashboard_exchange_usd: 'USD 交易账号',
    dashboard_exchange_xif: 'XIF 交易账号',
    dashboard_exchange_eth: 'ETH 交易账号',
    dashboard_exchange_btc: 'BTC 交易账号',
    dashboard_bonus: '奖励',
    dashboard_wallet: '钱包',
    account_title: "帐户",
    account_deposit_button: "转入",
    account_withdraw_button: "转出",
    account_send_button: '转出',
    account_receive_button: '转入',
    account_usd_saving: 'USD 账户',
    account_xif_wallet: 'XIF 钱包',
    account_bkn_wallet: 'BKN 钱包',
    account_spn_wallet: 'SPNC 钱包',
    account_btc_wallet: 'BTC 钱包',
    account_eth_wallet: 'Ethereum 钱包',
    account_usd_exchange: 'USD 交易账号',
    account_xif_exchange: 'XIF 交易账号',
    account_spn_exchange: 'SPNC 交易账号',
    account_eth_exchange: 'Ethereum 交易账号',
    account_btc_exchange: 'Bitcoin 交易账号',
    transaction_title: "交易详情",
    transaction_id: "交易ID",
    transaction_time: "创建时间",
    transaction_type: "类型",
    transaction_status: "状态",
    transaction_amount: "交易金额",
    transaction_from: "交易帐户",
    transaction_to: "接收帐户",
    transaction_details: '交易详情',
    transaction_fee: '交易费用',
    transaction_notes: '备注',
    address_from: '转账地址',
    address_to: '接收地址',
    withdraw_title: "提现",
    withdraw_title_sub: "提现到银行账户",
    withdraw_button: "确认提现",
    withdraw_button_progress: "交易中...",
    withdraw_name: "帐户名称",
    withdraw_number: "帐号",
    withdraw_swift: "Swift Code",
    withdraw_address: "银行地址",
    withdraw_confirm_title: "转出成功",
    withdraw_fiat_confirm_message: '{{withdraw_amount}} 已从您的帐户中转出，可用资金 {{available_amount}}',
    withdraw_coin_confirm_message: '{{withdraw_amount}} {{symbol}} 已从您的帐户中转出。',
    withdraw_confirm_button: "返回账号列表",
    withdraw_tip: "提示:您可以在设置中修改银行详细信息",
    bank_verify_button: '验证您的银行卡信息',
    transfer_title: "银行转账",
    deposit_title: "充值",
    deposit_title_sub: "使用信用卡充值",
    deposit_button: "确认充值",
    deposit_button_progress: "交易中...",
    deposit_transfer_prompt: "从其他银行账户充值？",
    deposit_transfer_button: "查看转账说明",
    deposit_confirm_title: "充值成功",
    deposit_confirm_message: "已发送到您的账户。可用资金",
    deposit_confirm_button: "返回首页",
    transfer_instructions: "通过银行充值非常简单，使用下面列出的银行账户详细信息，资金将直接转入您的美元账户。一旦交易已经处理并且资金已转入您的账户，您将通过电子邮件得到通知",
    transfer_info: "请确保您的帐户信息正确，如果相关编码不正确，我们将无法收到您的资金。",
    transfer_label_name: "帐户名称",
    transfer_label_ref: "参考",
    transfer_label_account: "帐号",
    transfer_label_swift: "SWIFT代码",
    transfer_label_address: "银行地址",
    deposit_eth_title: '转入以太币',
    deposit_eth_instructions: '转入以太币非常简单。 使用下面列出的账户详细信息, 以太币将转入您的以太币账户。 一旦交易完成，您将通过电子邮件得到通知。',
    deposit_eth_info: '请确保您输入的信息正确, 否则我们无法收到您的以太币。',
    deposit_eth_address: '以太币地址',
    withdraw_eth_title: '转出以太币',
    withdraw_eth_instructions: '转出以太币非常简单。 请填写您外部的以太币地址, 以太币将从您的以太币账户中转出。',
    withdraw_eth_info: '请确保您输入的信息正确, 否则您的以太币可能无法正常转出。',
    withdraw_eth_button: '转出',
    withdraw_eth_button_progress: '转出中...',
    deposit_btc_title: '转入比特币',
    deposit_btc_instructions: '转入比特币非常简单。 使用下面列出的账户详细信息, 比特币将转入您的比特币账户。 一旦交易完成，您将通过电子邮件得到通知。',
    deposit_btc_info: '请确保您输入的信息正确, 否则我们无法收到您的比特币。',
    deposit_btc_address: '比特币地址',
    withdraw_btc_title: '转出比特币',
    withdraw_btc_instructions: '转出比特币非常简单。 请填写您外部的比特币地址, 比特币将从您的比特币账户中转出。',
    withdraw_btc_info: '请确保您输入的信息正确, 否则您的比特币可能无法正常转出。',
    withdraw_btc_button: '转出',
    withdraw_btc_button_progress: '转出中...',
    deposit_erc20_title: '转入',
    deposit_erc20_instructions: '转入代币非常简单。 使用下面列出的账户详细信息, 代币将转入您的账户。 一旦交易完成，您将通过电子邮件得到通知。',
    deposit_erc20_info: '请确保您输入的信息正确, 否则您的代币可能无法正常转出。',
    deposit_erc20_label_ref: '您在 X Infinity 的代币地址',
    withdraw_erc20_title: '转出',
    withdraw_erc20_instructions: '转出代币非常简单。 请填写您的代币地址, 代币将从您的账户中转出。',
    withdraw_erc20_info: '请确保您输入的信息正确, 否则可能无法正常转出。',
    withdraw_erc20_button: '转出',
    withdraw_erc20_button_progress: '交易中...',
    balance: '余额',
    withdraw_prompt_message: '转出:{{withdraw_amount}},包含费用 {{fee}},预计接收:{{estimate_amount}}.',
    symbol: '货币',
    account_balance: '账户余额',
    account_locked: '锁定数额',
    account_available_balance: '可用余额',
    transactions_list: '交易列表',
    no_accounts: '没有账号....'
  },
  transactions: {
    exchange_bank_transfer: '交易转账',
    bank_deposit: '充值',
    transfer: 'Coin转账',
    transfer_generic: 'Coin转账',
    exchange_coin_transfer: '交易转账',
    fee: '费用',
    exchange_transfer_locked: '交易转账',
    exchange_transfer: '交易转账',
    exchange_trade: '交易结算',
    bank_withdraw: '提现',
    eth_withdraw: '转出以太币',
    eth_deposit: '转入以太币',
    btc_withdraw: '转出比特币',
    btc_deposit: '转入比特币',
    presale_transfer: '预售转账',
    xif_buy: '购买',
    no_transaction_found: '还没有交易数据',
    airdrop: 'Coin空投',
    withdraw: '转出',
    deposit: '转入',
    recent_transactions: '最近转账'
  },
  send: {
    contacts_empty: "还没有联系人，创建一个联系人",
    contacts_not_found: "找不到联系人",
    contacts_title: "转账",
    contacts_send_to: "转账",
    contacts_create_title: "添加联系人",
    contacts_create_button: "创建联系人",
    contacts_create_button_progress: "创建中...",
    contacts_update_title: "编辑联系人",
    contacts_update_button: "更新联系人",
    contacts_update_button_progress: "正在更新...",
    send_confirm_title: "转账成功",
    send_confirm_message: "已转出",
    send_confirm_button: "返回首页",
    send_title: "转账",
    send_prompt: "转账",
    send_available_amount: "可用数量",
    send_button: "发送硬币",
    send_fee: '手续费',
    send_total: '发送总额',
    send_button_progress: "正在发送...",
    scan_title: "扫描二维码",
    scan_tip: "扫描二维码添加联系人",
    scan_btc_tip: '使用二维码扫描比特币地址',
    scan_eth_tip: '使用二维码扫描以太币地址',
    coin_not_enough: "你没有足够的XIF",
    recipient_address: '接收地址',
    send_amount: '数量',
    send_notes: '备注',
    send_inc_fee: '包含转账费用',
    address: '地址',
    symbol: '货币符号'
  },
  trade: {
    tab_buy: "买入",
    tab_sell: "卖出",
    label_trade: '交易',
    tab_history: "交易历史",
    commit_title: '买入XIF',
    commit_confirm_title: '订单处理中',
    commit_confirm_message_start: '买入订单已创建，订单价值：',
    commit_confirm_message_end: '交易需要一些时间，我们会在交易完成时通知您。',
    buy_confirm_title: "买入订单已创建",
    buy_confirm_message_start: "创建买入订单",
    buy_confirm_message_end: "XIF",
    buy_confirm_button: "转到订单列表页",
    buy_title: "购买XIF",
    buy_button: "购买XIF", // (9月17号停售)
    buy_button_progress: "交易中...",
    sell_confirm_title: "卖出订单已创建",
    sell_confirm_message_start: "创建卖出订单",
    sell_confirm_message_end: "XIF",
    sell_confirm_button: "转到订单列表页",
    sell_title: "卖出XIF",
    sell_button: "卖出XIF",
    sell_button_progress: "交易中...",
    order_confirm_title: '订单已创建',
    order_confirm_message: '订单已创建：{{order_type}} {{amount}} {{symbol}} Coins.',
    order_confirm_button: '返回首页',
    order_create_button: '创建订单',
    orders_empty: "还没有订单",
    history_title: "订单历史记录",
    market_label: "市场价格",
    market_bid: "喊价",
    market_ask: "需求",
    market_price_label: "价格",
    coin_unit: "硬币",
    type_buy: "买入",
    type_sell: "卖出",
    status_open: "开放",
    status_closed: "已关闭",
    status_cancelled: "已取消",
    status_pending: '等待中',
    status_locked: '已锁定',
    status_transfer: '转出',
    cancel_button: "取消订单",
    cancel_confirm_title: "订单已取消",
    cancel_confirm_message: "您的订单已取消。",
    cancel_confirm_button: "转到订单列表页",
    detail_title: "订单明细",
    detail_order: '订单',
    detail_type: "类型",
    detail_price: '价格',
    detail_status: "状态",
    detail_created: "创建时间",
    detail_unit_price: "单价",
    detail_order_amount: "订单数量",
    detail_total_price: "订单总额",
    detail_fees: "费用",
    detail_transfer_fees: '交易费用',
    detail_settle_amount: "结算数量",
    detail_settle_price: "订单结算总额",
    detail_match_orders: "匹配订单",
    detail_transaction_hash: 'Transaction Hash',
    detail_total_settled: '结算数量',
    set_max_amount: '最大数量',
    bonus_purchase_msg: '现在购买奖励5%',
    fee_estimate_msg: '以上费用仅为估计值，实际费用取决于比特币或以太币网络和供求情况。',
    no_orders_found: '还没有订单',
    commit_verify_pin_button: '验证你的识别码',
    commit_verify_pin_button_progress: '验证中...',
    orders_title: '我的订单',
    recent_orders: '最近订单',
    label_total: '总计',
    label_amount: '数量',
    trading_pair: '交易对',
    date_range: '日期范围'
  },
  settings: {
    home_title: "我的设置",
    home_details_change: "我的详细信息",
    home_base_address: "我的{{symbol}}地址",
    home_eth_address: '我的以太币地址',
    home_btc_address: '我的比特币地址',
    home_bank_details: "我的银行信息",
    home_verify_id: "验证我的身份证",
    home_password_change: "更改密码",
    home_avatar_update: "更新头像",
    home_support: "支持和帮助",
    home_logout_button: "注销",
    help_contact_us: '联系我们',
    help_contact_prefix: '如需帮助，请发送电子邮件到:',
    detail_title: "我的详细资料",
    detail_button_phone: '更新手机号',
    detail_button: "更新",
    detail_button_progress: "更新中...",
    verify_email_button: '重新发送验证邮件',
    verify_email_progress: '发送中...',
    qrcode_title: "我的{{clientname}}钱包",
    eth_address_title: '我的以太币地址',
    btc_address_title: '我的比特币地址',
    qrcode_tip: '扫描二维码添加联系人或者支付',
    bank_title: "我的银行信息",
    bank_button: "更新",
    bank_button_progress: "更新中...",
    bank_button_modify: '修改银行信息',
    bank_button_modify_progress: '修改中...',
    bank_verify_button: '验证银行信息',
    bank_verify_button_progress: '验证中...',
    verify_alert: "请上传您的身份证照片",
    verify_title: "验证我的身份证",
    id_verify_button: "认证",
    id_verify_button_progress: "正在上传...",
    verify_choose_photo: "选择照片",
    password_title: "更改密码",
    password_button: "更改密码",
    password_button_progress: "正在更新...",
    avatar_title: "更改头像",
    avatar_take_photo: "拍照",
    avatar_choose_photo: "选择照片",
    avatar_button: "上传新照片",
    avatar_button_progress: "正在更新...",
    bank_remove_linkedcard_button: '移除关联的银行卡',
    bank_remove_linkedcard_button_progress: '移除中...',
    verify_confirm_title: '上传成功',
    verify_confirm_button: '回到首页',
    bank_verify_confirm_text: '您的银行卡已验证',
    qrcode_incorrect: '二维码未识别',
    phone_change_title: '修改手机号码',
    phone_change_instructions: '请验证您的新手机号码',
    phone_current_title: '您当前的电话号码是:',
    phone_not_verified: '你的电话号码未验证。',
    update_pin_title: '更改识别码',
    update_pin_button: '更改识别码',
    update_pin_button_progress: '正在更新...',
    bank_not_verified_instructions: '您的银行资料未被核实。请在下面输入您的银行帐户资料。',
    bank_verifying_instructions: '您的银行账户有两笔小额存款。请在下面输入金额及验证码。',
    bank_verified1_instructions: '您的银行资料已核实。',
    bank_verified2_instructions: '如果您希望修改您的银行资料，则需要再次进行验证过程。',
    linked_credit_card: '您的信用卡',
    credit_card_num: '卡号: XXXXXXXXXXXX',
    credit_store_instructions: '(我们不会报存您的银行卡信息，银行卡信息由Stripe.com担保)',
    setting_confirm_title: '设置已更新',
    setting_confirm_text: '设置已更新成功',
    setting_next_route_text: '回到设置',
    setting_confirm_route_text: '回到设置',
    success: '成功',
    setting_email_sent: '确认邮件已发送',
    setting_profile_updated_message: '个人信息更新成功',
    setting_password_updated_message: '密码更新成功',
    email_verify_error: '验证您的电子邮件出错。',
    email_verify_success: '您的电子邮件已被成功验证。',
    my_referrer_link: '我的推荐链接',
    security_update_title: '安全设置',
    security_update_instructions: '更改您的两步认证',
    label_2fa_type: '类型',
    label_login_2fa: '登录',
    label_trade_2fa: '交易',
    label_withdraw_2fa: '提现',
    totp_settings: 'TOTP设置',
    totp_settings_title: '绑定认证设备',
    totp_button: '绑定认证设备',
    totp_button_progress: '绑定中...',
    totp_instructions: '请使用认证APP扫描上面的二维码。我们推荐使用Authy或谷歌认证APP。通过认证APP扫描二维码后，会创建一个新的配置文件，你将看到一个6位数的识别码，请在下面的文本框中输入此识别码，等该识别码过期后，在下一个文本框中输入下一个识别码。',
    totp_already_set_instructions: '您的一次性密码设备已经设置好了。',
    label_temporary_authenticator_code: '临时验证码',
    update_security: '安全设置',
    update_notifications: '通知设置',
    label_coin_receive: '收到XIF',
    label_trade_complete: '交易完成',
    label_bank_withdraw: '银行卡提现',
    security_events: '登录日志',
    security_question_button: '设置安全问题',
    security_question_button_progress: '设置中...',
    update_security_questions: '安全问题',
    set_security_questions_instructions: '设置您的安全问题，以便将来您可以重新设置您的密码。',
    verify_phone_title: '验证您的手机',
    submit_answers_button: '提交答案',
    submit_answers_button_progress: '提交中...',
    retrieve_questions_button: '获取问题',
    label_answer_questions: '安全问题答案',
    no_identification_uploaded: '未上传身份证明文件。'
  },
  input_label: {
    email: "电子邮件",
    password: "密码",
    password_confirm: "确认密码",
    password_new: "新密码",
    password_new_confirm: "确认新密码",
    verification_code: "验证码",
    firstname: "名字",
    lastname: "姓氏",
    phone: "手机号码",
    phone_new: '新手机号码',
    xif_address: "XIF地址",
    amount_USD: "美元",
    card_name: "卡名",
    card_number: "卡号",
    card_expiry_month: "Exp月（MM）",
    card_expiry_year: "Exp年（YYYY）",
    card_ccv: "CCV",
    contact_name: "联系人姓名",
    trade_balance: "可用数量",
    trade_amount: "交易数量",
    trade_unit_price: "单价",
    trade_order_value: "订单价值",
    trade_order_fee: "费用（含）",
    trade_market_price: '市场价',
    eth_address: '以太币地址',
    btc_address: '比特币地址',
    notes: '备注',
    swift: "银行代码",
    verification_amount: '验证金额 1',
    verification_amount_2: '验证金额 2',
    verification_code: '验证码',
    account_name: "帐户名称",
    account_number: "帐号",
    bank_address: "银行地址",
    verify_id_type: "类型",
    verify_id_name: "姓名",
    verify_id_number: "编号",
    verify_id_expiry: "到期日期",
    verify_id_address: "地址",
    verify_type_passport: "护照",
    amount: '数量',
    referrer: '推荐人代码',
    trade_fee_estimate: '预计费用',
    pin_new: '新识别码',
    pin_new_confirm: '确认新识别码',
    ext_address: '代币地址',
    question: '问题',
    answer_to_question: '安全问题答案',
    document_type: '文件类型',
    bank_name: '银行名称',
    country_code: '国家代码',
    currency_code: '货币代码',
  },
  system: {
    name: '文件管理系统',
    notify: "请验证您的电子邮件",
    header_balance: "帐户余额",
    help_title: "帮助",
    help_contents: "帮助页面",
    coming_soon: 'XIF将于2018年8月8日推出。请访问www.xinfinity.io获取更多关于奖励计划的更新。',
    verify_mobile: '获取验证码',
    retry_verify_mobile: '重新获取验证码',
    choose_currency: '选择货币',
    delete: '删除',
    i_agree: '我同意',
    terms_conditions: '条款与条件',
    and: '和',
    privacy_policy: '隐私政策',
    when_registering_an_account: '当注册账号时。',
    loading: '加载中...',
    back_to_home: '返回首页',
    submit_verify_code: '提交',
    submit_verify_code_progress: '提交...',
    enter_verfication_num: '请输入您的验证码',
    time: '时间',
    agent: '终端',
    search: '查询',
    empty_data: '无数据...'
  },
  token: {
    empty_token_pairs: 'No token pairs...',
    empty_tokens: 'No tokens...',
    token_name: '名称',
    token_listed: '登记时间',
    empty_token: 'No token info...',
    token: 'Token',
    token_list_title: 'Tokens',
    name: '名称',
    symbol: '代币符号',
    description: '描述',
    asset: '资产',
    created: '创建时间',
    modified: '修改时间',
    token_legals: 'Token Legals'
  },
  news: {
    empty_news: '还没有新闻...',
    news_title: '新闻',
    create_button: '添加新闻',
    create_title: '添加新闻',
    title: '标题',
    summary: '概要',
    image: '图片',
    content: '内容',
    update_title: '更新新闻',
    original_image: '原图',
    new_image: '新图',
    update_button: '更新新闻',
  },
  assets: {
    empty_assets: '还没有资产...',
    assets_listed: '登记时间',
    assets_category: '资产类别',
    assets_title: '资产列表',
    assets_create_button: '添加资产',
    assets_create_title: '添加资产',
    assets_name: '名称',
    assets_description: '描述',
    assets_data: '资产数据',
    assets_update_button: '更新资产',
    assets_update_title: '更新资产',
    assets_detail_title: '资产详细信息',
    assets_edit_button: '编辑',
    assets_created: '创建时间',
    assets_modified: '修改时间',
    assets_status: '状态',
    assets_created_by: '创建人',
  },
  fees: {
    fee_estimation: '费用估算 (1 coin)',
    calculators: '计算器',
    send: '转出',
    fee: '费用',
    receive: '收到',
    fee_estimation_instructions: '重要提示：下面提供的费用计算只是一个估计；当交易发生时，实际费用可能会有所不同。'
  },
  update: {
    title: "需要更新",
    contents: "请先下载最新版本的APP，欢迎与我们联系以获取更多信息。"
  },
  errors: {
    empty_email: "请填写您的电子邮件地址",
    empty_password: "请输入您的密码",
    empty_password_confirm: "请重新输入您的密码",
    empty_firstname: "请添加您的名字",
    empty_lastname: "请添加您的姓氏",
    empty_contact_firstname: "请输入名字",
    empty_contact_lastname: "请输入姓氏",
    empty_contact_xif_address: "请输入一个XIF地址",
    empty_eth_address: '请输入以太币地址',
    empty_btc_address: '请输入比特币地址',
    empty_amount: "请输入金额",
    empty_swift: "请输入银行SWIFT代码",
    empty_account_name: "请输入帐户名称",
    empty_account_number: "请输入帐号",
    empty_bank_address: "请输入您的银行地址",
    empty_card_name: "请输入卡名",
    empty_card_number: "请输入卡号",
    empty_card_exp_month: "请输入信用卡到期月份",
    empty_card_exp_year: "请输入信用卡到期年份",
    empty_card_ccv: "请输入信用卡CCV编号",
    empty_price: "请输入价格",
    empty_name: "请输入名字",
    empty_id_number: "请输入身份证号码",
    empty_id_expiry: "请输入身份证失效日期",
    empty_verification: "请输入验证码",
    empty_verification_amount: '请输入验证的金额',
    minimum_firstname: "名字至少需要2个字符",
    minimum_lastname: "姓氏需要至少2个字符",
    invalid_email: "请输入正确的电子邮件地址",
    invalid_password: "密码至少6个字符，至少包含1个数字，一个大写字母和1个小写字母",
    invalid_password_confirm: "密码不匹配",
    invalid_password_new: "请设置您的新密码",
    invalid_amount: "请输入正确的金额",
    invalid_price: "请输入正确的价格",
    invalid_card_name: "请输入正确的名称",
    invalid_card_exp_month: "请输入正确的过期月份",
    invalid_contact: "您无法将自己添加为联系人",
    incorrect_verification_code: '请输入正确的验证码',
    empty_pin: "请输入4位数字",
    empty_pin_confirm: "请重新输入您的密码",
    invalid_pin: "请输入4位数字",
    invalid_pin_confirm: "数字密码不匹配",
    invalid_phone_number: '无效的手机号码',
    commit_empty_user_pin: '在进行交易前您应先设置PIN码'
  },
  file: {
    upload_button: '上传文件',
    upload_title: '上传文件',
    label_directory: '目录',
    label_file: '文件',
    label_permissions: '权限',
    log_title: '文件访问日志',
    create_group_button: '创建权限组',
    create_group_button_progress: '创建中...',
    group_list_title: '权限组 & 用户',
    group_create_title: '创建权限组',
    label_name: '名称',
    label_created: '创建时间',
    group_user_title: '管理权限组',
    label_email: '邮件',
    assign_user_button: '添加用户到组',
    user_group_title: '组中的用户',
    group_edit_title: '权限组管理',
    update_group_button: '更新组',
    delete_group_button: '删除组',
    create_directory_button: '创建目录',
    edit_directory_button: '编辑目录',
    label_total: '总数',
    delete_group_confirm_text: '是否确定要删除此组 ?',
    delete_file_confirm_text: '是否确定要删除此文件 ?',
    file_detail_title: '文件详细信息',
    label_owner: '上传人',
    label_size: '文件大小',
    label_file_integrity: '文件验证',
    label_file_name: '文件名称',
    label_views: '浏览次数',
    label_downloads: '下载次数',
    label_file_id: '文件 ID',
    download_file_button: '下载文件',
    verify_file_button: '验证文件',
    update_permissions_button: '更新权限',
    delete_file_button: '删除文件',
    update_permissions_title: '更新权限',
    label_permission: '权限',
    update_button: '更新',
    close_button: '关闭',
    file_access_title: '文件访问日志',
    edit_directory_title: '编辑目录',
    label_current_directory: '当前目录',
    delete_directory_button: '删除目录',
    update_button_progress: '更新中...',
    update_logs_title: '更新日志',
    create_directory_title: '创建目录',
    label_parent_directory: '父目录',
    create_button: '创建',
    create_button_progress: '创建中...',
    action: '操作',
    log_detail_title: '日志详细信息',
    label_details: '详细信息',
    label_type: '类型',
    label_ip: 'IP',
    label_agent: '设备',
    remove_user_confirm_text: '是否确定要从此组中移除此用户 ?',
    remove_button: '移除'
  }
};
